export interface ColorConfig {
  hex: string;
  background: string;
  border: string;
  text: string;
  textBold: string;
}

export const RISK_COLOR_PALETTE = {
  hta: {
    hex: "#3b82f6",
    background: "bg-blue-50",
    border: "border-blue-200", 
    text: "text-blue-700",
    textBold: "text-blue-900"
  } as ColorConfig,
  
  beacon: {
    hex: "#10b981",
    background: "bg-emerald-50",
    border: "border-emerald-200",
    text: "text-emerald-700", 
    textBold: "text-emerald-900"
  } as ColorConfig,
  
  otc: {
    hex: "#f59e0b",
    background: "bg-amber-50",
    border: "border-amber-200",
    text: "text-amber-700",
    textBold: "text-amber-900"
  } as ColorConfig,
  
  brokerage: {
    hex: "#8b5cf6", 
    background: "bg-violet-50",
    border: "border-violet-200",
    text: "text-violet-700",
    textBold: "text-violet-900"
  } as ColorConfig,
  
  dpq: {
    hex: "#06b6d4",
    background: "bg-cyan-50",
    border: "border-cyan-200", 
    text: "text-cyan-700",
    textBold: "text-cyan-900"
  } as ColorConfig,
  
  cash: {
    hex: "#ef4444",
    background: "bg-red-50",
    border: "border-red-200",
    text: "text-red-700",
    textBold: "text-red-900"
  } as ColorConfig,
  
  basis: {
    hex: "#3b82f6", // Same hex as HTA for consistency across breakdowns
    background: "bg-blue-50", // Match HTA background since they have same hex
    border: "border-blue-200",
    text: "text-blue-700", 
    textBold: "text-blue-900"
  } as ColorConfig,
  
  unprotected: {
    hex: "#9ca3af",
    background: "bg-gray-50",
    border: "border-gray-200",
    text: "text-gray-700",
    textBold: "text-gray-900"
  } as ColorConfig,
  
  // Special colors for offers and other elements
  offers: {
    hex: "#f97316",
    background: "bg-orange-50",
    border: "border-orange-200", 
    text: "text-orange-700",
    textBold: "text-orange-900"
  } as ColorConfig,
  
  dp: {
    hex: "#06b6d4", // Same as DPQ
    background: "bg-cyan-50", // Match DPQ background since they have same hex
    border: "border-cyan-200",
    text: "text-cyan-700",
    textBold: "text-cyan-900"
  } as ColorConfig
} as const;

export type RiskColorKey = keyof typeof RISK_COLOR_PALETTE;

export function getRiskColor(key: RiskColorKey): ColorConfig {
  return RISK_COLOR_PALETTE[key];
}

export function getRiskHexColor(key: RiskColorKey): string {
  return RISK_COLOR_PALETTE[key].hex;
}